import { CodeField } from 'bricks-ui/packages/bricks-ui';

export default CodeField;
